import { API_CUSTOM_HEADERS, ChatbotWidgetConfigDto } from '@endion/types';
import { callApi, getEndpoint } from '../utils/api.utils';

export function getSanitizedCustomerChatbot({ chatbotApiKey }: { chatbotApiKey: string }) {
  const headers = new Headers();
  headers.set(API_CUSTOM_HEADERS.X_CHATBOT_API_KEY, chatbotApiKey);

  return callApi<ChatbotWidgetConfigDto>(getEndpoint('chatbot/config'), {
    method: 'GET',
    headers,
  });
}
